import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { CreateExportInterfaceEmailTemplateDTO, ExportInterfaceEmailTemplateClient, ExportInterfaceEmailTemplateDTO, FilterDTO, FilterOperator, SortDirection, UpdateExportInterfaceEmailTemplateDTO } from "src/app/base/models/models.swagger.generated";
import { ToastService } from "src/app/base/services/toast.service";
import { ShowInactiveService } from "src/app/base/shared/grid-base/show-inactive.service";
import { IAdaptorService } from "src/app/base/shared/syncfusion/adaptor-service.interface";
import { IPagedItems } from "src/app/base/shared/syncfusion/paged-items.interface";
import { ErrorType } from "src/app/core/routing/error-types";

@Injectable()
export class EmailTemplatesOverviewService extends ShowInactiveService implements IAdaptorService {
  public oneTimeFilterTemplateId: number;

  constructor(
    private emailTempalteClient: ExportInterfaceEmailTemplateClient,
    private toastService: ToastService)
  {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    if (!sortBy) {
      sortBy = 'TemplateName';
    }
    if (filters == null) {
      filters = [];
    }
    if (this.oneTimeFilterTemplateId) {
      filters.push(new FilterDTO({ field: 'id', operator: FilterOperator.Equal, value: this.oneTimeFilterTemplateId.toString(), isComplex: false}));
      this.oneTimeFilterTemplateId = null;
    }
    return this.emailTempalteClient.searchExportInterfaceEmailTemplates(skip, take, sortBy, sortDirection, false, filters);
  }

  public addRecord(): Observable<ExportInterfaceEmailTemplateDTO> {
    let createTemplate = new CreateExportInterfaceEmailTemplateDTO({});
    return this.emailTempalteClient.createExportInterfaceEmailTemplate(createTemplate)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.export-configuration.email-templates.messages.create.success-title',
            'i18n.domain.export-configuration.email-templates.messages.create.success-message',
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public updateRecord(updateTemplate: UpdateExportInterfaceEmailTemplateDTO): Observable<ExportInterfaceEmailTemplateDTO> {
    return this.emailTempalteClient.updateExportInterfaceEmailTemplate(updateTemplate)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.export-configuration.email-templates.messages.update.success-title',
            'i18n.domain.export-configuration.email-templates.messages.update.success-message',
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError, error.response);
          }
          return throwError(() => error);
        }),
      );
  }

  public deleteRecord(id: number) {
    return this.emailTempalteClient.deleteExportInterfaceEmailTemplate(id)
      .pipe(
        tap(() => {
          this.toastService.showSuccess(
            'i18n.domain.export-configuration.email-templates.messages.delete.success-title',
            'i18n.domain.export-configuration.email-templates.messages.delete.success-message',
          );
        }),
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }
}
